// src/store/userSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  email: '',
  birthDetails: {},
  isLoggedIn: false,
  credits: 0,
  dailyFreeCredits: 0, // remaining free questions today (verified-email users only)
  emailVerified: true,  // Defaults true so banner is hidden for guests / pre-existing users (treat absent as verified)
  subscription: null, // { status, credits, currentPeriodEnd }
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      const { credits, dailyFreeCredits, subscription, ...rest } = action.payload;
      Object.assign(state, rest);
      state.credits = typeof credits === 'number' ? credits : 0;
      state.dailyFreeCredits = typeof dailyFreeCredits === 'number' ? dailyFreeCredits : 0;
      state.subscription = subscription || null;
    },
    logout() {
      return initialState;
    },
    // Apply the balance fields carried on question/auth responses in one shot.
    // Only defined numbers are applied, so partial payloads can't zero a balance.
    setBalances(state, action) {
      const { credits, dailyFreeCredits } = action.payload || {};
      if (typeof credits === 'number') state.credits = credits;
      if (typeof dailyFreeCredits === 'number') state.dailyFreeCredits = dailyFreeCredits;
    },
    setSubscription(state, action) {
      state.subscription = action.payload;
    },
  },
});

export const {
  setUser,
  logout,
  setBalances,
  setSubscription,
} = userSlice.actions;

export default userSlice.reducer;
